import PropTypes from "prop-types";
import { useState } from "react";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";

import {
  CircularProgress,
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  Box,
} from "@mui/material";
import MDButton from "components/MDButton";

import { useReactMediaRecorder } from "react-media-recorder";

function AudioRecorder({ displayName, fieldRef, isOptional, options }) {
  console.log(options ? "" : "");
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [recordedAudio, setRecordedAudio] = useState(null);
  const [openRecordDialog, setOpenRecordDialog] = useState(false);

  function saveMediaBlob(blobUrl, blob) {
    // console.log(blobUrl);
    const reader = new FileReader();
    reader.readAsDataURL(blob);
    reader.onloadend = function () {
      const base64data = reader.result;
      // console.log(base64data);
      setRecordedAudio(base64data);
    };
  }

  const { status, startRecording, stopRecording, mediaBlobUrl, clearBlobUrl } =
    useReactMediaRecorder({
      video: false,
      onStop: (blobUrl, blob) => {
        saveMediaBlob(blobUrl, blob);
      },
    });

  return (
    <MDBox mt={3}>
      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={5000}
        onClose={() => showFieldError(false)}
        open={fieldError}
      >
        <Alert severity="error" sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      <Dialog open={openRecordDialog} fullWidth maxWidth="sm">
        <DialogTitle>
          <MDBox>Record Audio</MDBox>
        </DialogTitle>
        <DialogContent>
          <MDBox mt={2} mb={3} align="center">
            <MDBox>
              <Box mt={1}>
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant={status === "recording" ? "indeterminate" : "determinate"}
                    size={120}
                    thickness={2}
                    color={status === "recording" ? "success" : "dark"}
                    value={100}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Icon color={status === "recording" ? "success" : "dark"} fontSize="large">
                      {status === "recording" ? "settings_voice" : "mic_none"}
                    </Icon>
                  </Box>
                </Box>
              </Box>
              <Box mt={1}>
                <MDButton
                  size="small"
                  circular
                  variant="contained"
                  color={status === "recording" ? "error" : "success"}
                  onClick={() => {
                    if (status === "recording") {
                      stopRecording();
                    } else {
                      clearBlobUrl();
                      startRecording();
                    }
                  }}
                >
                  {status === "recording" ? "Stop" : "Start"} Recording
                </MDButton>
              </Box>
            </MDBox>
            <MDBox mt={3}>
              {mediaBlobUrl ? (
                <audio src={mediaBlobUrl} controls>
                  <track default kind="captions" srcLang="en" />
                </audio>
              ) : (
                <> </>
              )}
            </MDBox>
          </MDBox>
        </DialogContent>
        <DialogActions>
          <MDButton
            onClick={() => {
              setOpenRecordDialog(false);
            }}
            color="dark"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>close</Icon>
          </MDButton>
          &nbsp;&nbsp;
          <MDButton
            onClick={() => {
              clearBlobUrl();
              setRecordedAudio(null);
            }}
            color="error"
            iconOnly
            circular
            variant="outlined"
          >
            <Icon>delete</Icon>
          </MDButton>
          <MDButton
            color="success"
            variant="outlined"
            iconOnly
            circular
            onClick={() => {
              if (status === "recording") {
                stopRecording();
                setOpenRecordDialog(false);
                return;
              }

              if (recordedAudio === null) {
                setErrorMsg("Audio recording failed");
                showFieldError(true);
                return;
              }
              setOpenRecordDialog(false);
            }}
          >
            <Icon>save</Icon>
          </MDButton>
        </DialogActions>
      </Dialog>
      <MDBox>
        <Grid container spacing={3}>
          <Grid item xs={8} md={8} lg={8}>
            <MDTypography variant="h6" fontWeight="light" fontSize="small" mb={2}>
              {displayName}
            </MDTypography>
          </Grid>
          <Grid item xs={4} md={4} lg={4}>
            <MDBox align="right">
              <MDButton
                iconOnly
                size="small"
                variant="contained"
                color="primary"
                // startIcon={<Icon>location_on</Icon>}
                onClick={() => {
                  setOpenRecordDialog(true);
                }}
              >
                <Icon>settings_voice</Icon>
              </MDButton>
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <MDBox>
        {mediaBlobUrl ? (
          <audio src={mediaBlobUrl} controls>
            <track default kind="captions" srcLang="en" src={mediaBlobUrl} />
          </audio>
        ) : (
          <> </>
        )}
      </MDBox>
      <input type="hidden" id={`dff_${fieldRef}`} name={`${fieldRef}`} value={recordedAudio} />
    </MDBox>
  );
}

// Typechecking props of the Transaction
AudioRecorder.propTypes = {
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

AudioRecorder.defaultProps = {
  options: null,
};

export default AudioRecorder;
